import * as React from 'react';

export const Homepage: React.SFC = () => (
  <div>
    <h1>Welcome to metropolis!</h1>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/Homepage.tsx